<dx-data-grid
  id="gridContainer"
  [dataSource]="dataSource"
  [showBorders]="true"
  [focusedRowEnabled]="false"
  [focusedRowIndex]="0"
  [allowColumnResizing]="true"
  [columnAutoWidth]="true"
  [columnResizingMode]="columnResizingMode"
  [showColumnLines]="true"
  [showRowLines]="true"
  [rowAlternationEnabled]="false"
  [allowColumnReordering]="true"
  [wordWrapEnabled]="false"
  (onExporting)="onExporting($event)"
  >

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-header-filter [visible]="true"  [allowSearch]="true"></dxo-header-filter>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

  <dxo-editing
    mode="popup"
    [allowAdding]="false"
    [allowUpdating]="false"
    [allowDeleting] ="true"
    [useIcons]="true"
    >
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
  </dxo-editing>

  <dxi-column
    dataField="id"
    [formItem]="{ visible: false }"
    [visible]="false"
    [allowEditing]="false"
    >
  </dxi-column>
  <dxi-column
    dataField="data"
    format="dd/MM/yyyy"
    dataType="date"
    [sortIndex]="1"
    sortOrder="desc">
    <dxi-validation-rule type="required" message="Selezionare la data"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="utenteStr"
    [formItem]="{ visible: false }"
    [visible]="true"
    [allowEditing]="false">
  </dxi-column>

  <dxi-column
    dataField="idArticolo"
    caption="Articolo">
    <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr">

    </dxo-lookup>
    <dxi-validation-rule type="required" message="Selezionare l'articolo"></dxi-validation-rule>
  </dxi-column>
  @if (gestMatricole) {
    <dxi-column
      dataField="idArticoloMatricola"
      caption="Matricola">
      <dxo-lookup [dataSource]="listArticoliMatricola" valueExpr="id" displayExpr="matricola">
      </dxo-lookup>
    </dxi-column>
  }
  <dxi-column
    dataField="idCausale"
    caption="Causale">
    <dxo-lookup [dataSource]="listCaus" valueExpr="id" displayExpr="descrizione">

    </dxo-lookup>
    <dxi-validation-rule type="required" message="Selezionare la causale"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="note">
  </dxi-column>
  <dxi-column
    dataField="qta"
    dataType="number"
    [formItem]="{ visible: true }"
    [visible]="false"
    [allowEditing]="true">
    <dxi-validation-rule type="required" message="Inserire la quantità"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="qtaRealValue"
    caption="Qta"
    dataType="string"
    [formItem]="{ visible: false }"
    [visible]="true"
    [allowEditing]="false"
    cellTemplate="qtaTemplate">

  </dxi-column>
  <div *dxTemplate="let d of 'qtaTemplate'" [class]="{'inc' :d.data.qtaRealValue > 0, 'dec': d.data.qtaRealValue <= 0}">
    <div class="diff">{{abs(d.data.qtaRealValue) | number:'1.2-2'}}</div>
  </div>


</dx-data-grid>
